import { render, staticRenderFns } from "./radioForm.vue?vue&type=template&id=1a3b9640&scoped=true&"
import script from "./radioForm.vue?vue&type=script&lang=js&"
export * from "./radioForm.vue?vue&type=script&lang=js&"
import style0 from "./radioForm.vue?vue&type=style&index=0&id=1a3b9640&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3b9640",
  null
  
)

export default component.exports